import React from "react"
import Helmet from 'react-helmet'


import target from './img/target.png'


// Styles
import './Home.css'

import Nav from '../../components/Navbar/Nav'
import Header from '../../components/Header/Header'
import Info from '../../components/Info/Info'

export default function Home(){
    return(
        
        <React.Fragment>
            <Helmet>

                <title>¡Fer Projects 👨🏼‍🚀!</title>

            </Helmet>


            {/* BODY */}


            <Nav />

            <Header />


            <section className="section">

                <Info title='📌 PINNED APPS' pinn_app = {true} desc='I recommend you to check out these very interesting projects!' />




                <Info image='control' title='ABOUT ME' desc='I am Fernando Leguízamo, of Colombian nationality and resident in Colombia. I love artificial intelligence, science, video games and technology in general. From a very young age I initially headed down the path of front-end web development, but over time I realized my passion for data and data management. When I understood this fact, almost all my time was focused on understanding data and how to analyze it. Thus, over time, I learned Python up to the current medium-high level. With time, practice and study, I am looking to get a little deeper into AI and data science!' />


                <Info image='github' title='GITHUB RESUME' img_main = {target} />


                <Info image='folder' title='PERSONAL WORKS' desc="My creative process to get to the creation and development of software and scripts is based on creating things that I can actually use. 'If you can be a consumer of your own product, chances are it will be a good one'. That's how, needing different solutions to my problems, I created my own library of 'Tools', inspired by the adobe suite, I create applications that can be used for different solutions independent of their field." projects={true} />


            </section>


            <footer className="footer_div">

                <Info image='contact' title='MORE INFO' desc="More information. Contact me, hire me, work with me or learn more about me." more_info={true} />


            </footer>


        </React.Fragment>
        
    )
}